import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import NewLogo from "../../../assets/img/NewsImgs/newLogo.webp";
import { Link } from 'react-router-dom';

const NavbarRight = ({ data }) => {
    function classNames(...classes) {
        return classes.filter(Boolean).join(' ');
    }

    return (
        <div className="flex justify-start items-center" id="customLink">
            <div className="flex justify-start items-center ml-3">
                <Link to={"/"}>
                    <img src={NewLogo} className='w-[90px]' alt="Logo" />
                </Link>
            </div>
            <div className="flex justify-start items-center">
                {
                    data?.filter(x => x.isMainPage == true).map((item) => {
                        return (

                            <Menu as="div" className="relative inline-block text-left">
                                <div>
                                    <a
                                        href={"/archive/" + item.categorySlug}
                                        className="inline-flex w-full justify-center items-center test bg-mainColor2 px-5 border-l-[1px] border-white pb-[2px] text-white font-IRANYekanMedium text-[18px] e1440:text-[15px] e1440:xl:text-[10px]"
                                    >
                                        {item.categoryName}
                                    </a>
                                </div>
                            </Menu>
                        )
                    })
                }
                <Menu as="div" className="relative inline-block text-left">
                                <div>
                                    <a
                                        href={"/archive/" + "all"}
                                        className="inline-flex w-full justify-center items-center test bg-mainColor2 px-5 border-l-[1px] border-white pb-[2px] text-white font-IRANYekanMedium text-[18px] e1440:text-[15px] e1440:xl:text-[10px]"
                                    >
                                        آخرین اخبار
                                    </a>
                                </div>
                </Menu>

                <Menu as="div" className="relative inline-block text-left">
                    <MenuButton
                        className="inline-flex w-full justify-center items-center test bg-mainColor2 px-5 pb-[2px] text-white font-IRANYekanMedium text-[18px] e1440:text-[15px] e1440:xl:text-[10px]"
                    >
                        <span className="ml-2">سایر</span>
                        <svg
                            width="15"
                            height="9"
                            viewBox="0 0 15 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M7.59614 6.73921L13.885 0.536522C14.1442 0.280837 14.5597 0.285665 14.8131 0.547305C15.0664 0.808946 15.0616 1.22832 14.8024 1.48401L8.0492 8.14468C7.79194 8.39842 7.38025 8.39588 7.12609 8.13899L0.191894 1.13044C-0.0642248 0.871571 -0.0639264 0.452168 0.192561 0.193674C0.449048 -0.0648205 0.864597 -0.0645191 1.12072 0.194346L7.59614 6.73921Z"
                                fill="white"
                            />
                        </svg>
                    </MenuButton>
                    <MenuItems className="absolute z-50 right-0 mt-2 w-56 origin-top-right bg-white  rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        {
                            data?.filter(x => x.isMainPage != true).map((item) => {
                                return (
                                    <MenuItem>
                                        <a
                                            href={"/archive/" + item?.categorySlug}
                                            className='text-mainColor2 font-IRANYekanMedium text-[16px] xl:text-[10px] block p-3 text-right hover:text-nextColor'
                                        >
                                            {item?.categoryName}                                        </a>
                                    </MenuItem>
                                )
                            })
                        }
                        
                    </MenuItems>
                </Menu>
            </div>
        </div>
    );
};

export default NavbarRight;
